module.exports = __webpack_public_path__ + "img/AJK Board.66d7b6c7.png";